module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: _vm.ref,
    attrs: {
      "model": _vm.formData,
      "disabled": _vm.block || _vm.loading
    }
  }, [_c('div', {
    staticClass: "col-md-12 pa-2 justify-center text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.block && _vm.blockMessage) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "message": _vm.blockMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'col-md-12 pa-0 pt-3 justify-center ' + _vm.classFooter
  }, [(_vm.handlerSave) ? _c('ed-button', {
    attrs: {
      "color": _vm.colorButton,
      "label": _vm.labelButton,
      "disabled": _vm.block,
      "icon": "salvar",
      "size": "100%"
    },
    on: {
      "click": _vm.validar
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("form-footer")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2958ec62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdForm.vue
// module id = 1461
// module chunks = 45